import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  scan: belongsTo('a11y-scan', { inverse: null }),
});
